/**
 * Allys Article/Post Detail Skeleton
 *
 * Matches a typical article page: hero image, title block,
 * and long-form content area.
 * Includes navigation skeleton so the nav bar is always visible.
 */

import { AllysNavSkeleton } from './AllysNavSkeleton';

export function AllysArticleSkeleton() {
  return (
    <div className="min-h-screen bg-white">
      <AllysNavSkeleton />

      {/* Hero image */}
      <section className="relative w-full aspect-21/9 max-h-[50vh] bg-gray-200 skeleton-shimmer skeleton-stagger-1">
        <div className="absolute inset-0 bg-linear-to-t from-black/50 to-transparent" />
      </section>

      {/* Article content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="mb-10 space-y-4 skeleton-stagger-2">
          <div className="flex items-center gap-3">
            <div className="h-5 w-20 rounded-full bg-[#243462]/10 skeleton-shimmer" />
            <div className="h-4 w-24 rounded bg-gray-100 skeleton-shimmer" />
          </div>
          <div className="h-10 w-full rounded-lg bg-gray-200 skeleton-shimmer" />
          <div className="h-10 w-3/4 rounded-lg bg-gray-200 skeleton-shimmer" />
          <div className="flex items-center gap-4 pt-4">
            <div className="w-10 h-10 rounded-full bg-gray-200 skeleton-shimmer" />
            <div className="space-y-1.5">
              <div className="h-4 w-28 rounded bg-gray-200 skeleton-shimmer" />
              <div className="h-3 w-20 rounded bg-gray-100 skeleton-shimmer" />
            </div>
          </div>
        </div>

        <div className="space-y-6 skeleton-stagger-3">
          {[1, 2, 3].map((block) => (
            <div key={block} className="space-y-2.5">
              <div className="h-4 w-full rounded bg-gray-100 skeleton-shimmer" />
              <div className="h-4 w-full rounded bg-gray-100 skeleton-shimmer" />
              <div className="h-4 w-full rounded bg-gray-100 skeleton-shimmer" />
              <div className="h-4 w-5/6 rounded bg-gray-100 skeleton-shimmer" />
              <div className="h-4 w-2/3 rounded bg-gray-100 skeleton-shimmer" />
            </div>
          ))}

          <div className="aspect-video rounded-xl bg-gray-100 my-8 skeleton-shimmer" />

          {[1, 2].map((block) => (
            <div key={`b${block}`} className="space-y-2.5 skeleton-stagger-4">
              <div className="h-4 w-full rounded bg-gray-100 skeleton-shimmer" />
              <div className="h-4 w-full rounded bg-gray-100 skeleton-shimmer" />
              <div className="h-4 w-3/4 rounded bg-gray-100 skeleton-shimmer" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
